(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/redux-localstorage/assets/javascript/localstorage.js') >= 0) return;  svs.modules.push('/components/app/redux-localstorage/assets/javascript/localstorage.js');
"use strict";

function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


svs.app = svs.app || {};
svs.app.redux = svs.app.redux || {};
svs.app.ReduxLocalStorage = options => {
  const defaultOptions = {
    key: 'state',
    states: [],
    debounce: 0,
    expires: 0,
    pathDelimiter: '.',
    personalize: false,
    handleAction: null,
    saveStrategy: (data, options) => (options.personalize ? svs.components.personalized_storage : svs.components.Storage.browser).set(options.key, options.domain, data, options.expires),
    loadStrategy: options => (options.personalize ? svs.components.personalized_storage : svs.components.Storage.browser).get(options.key, options.domain),
    clearStrategy: options => svs.components.Storage.browser.remove(options.key, options.domain)
  };
  let debounceTimeout = null;
  if (!options.domain) {
    throw new Error('ReduxLocalStorage is missing required domain option');
  }
  options = _objectSpread(_objectSpread({}, defaultOptions), options);
  function beforeSave(store) {
    const _options = options,
      states = _options.states,
      saveStrategy = _options.saveStrategy,
      pathDelimiter = _options.pathDelimiter;
    if (states.length === 0) {
      saveStrategy(store.getState(), options);
    } else {
      const currentState = store.getState();
      const stateToSave = {};
      states.forEach(key => {
        const path = key.split(pathDelimiter);
        if (hasStateValue(path, currentState)) {
          updateStateToSave(path, currentState, stateToSave);
        }
      });
      saveStrategy(stateToSave, options);
    }
  }
  function hasStateValue(path, state) {
    const _path = _toArray(path),
      key = _path[0],
      remainingPath = _arrayLikeToArray(_path).slice(1);
    if (state[key] === undefined) {
      return false;
    }
    return remainingPath.length ? hasStateValue(remainingPath, state[key]) : true;
  }
  function updateStateToSave(path, currentState, stateToSave) {
    const _path2 = _toArray(path),
      key = _path2[0],
      remainingPath = _arrayLikeToArray(_path2).slice(1);
    if (remainingPath.length) {
      stateToSave[key] = {};
    } else {
      stateToSave[key] = currentState[key];
      return;
    }
    return updateStateToSave(remainingPath, currentState[key], stateToSave[key]);
  }
  return {
    middleware() {
      return store => next => action => {
        const _options2 = options,
          debounce = _options2.debounce;
        const returnValue = next(action);
        if (typeof action === 'object') {
          action = typeof options.handleAction === 'function' ? options.handleAction(action) : action;
          if (!action) {
            return;
          }
          if (debounce) {
            if (debounceTimeout) {
              clearTimeout(debounceTimeout);
            }
            debounceTimeout = setTimeout(() => {
              beforeSave(store);
            }, debounce);
          } else {
            beforeSave(store);
          }
          return returnValue;
        }
      };
    },
    load() {
      return options.loadStrategy(options);
    },
    clear() {
      options.clearStrategy(options);
    }
  };
};

 })(window);